import template from './sw-extension-adding-success.html.twig';
import './sw-extension-adding-success.scss';

/**
 * @package services-settings
 * @private
 */
export default {
    template,
};
